export default (function () {});